import React from 'react';
import styles from './AccessCodeOnlyForm.module.scss';
import Button from '../Button';

export default function AffirmationText({ student, handleContinue }) {
  return (
    <div className={styles.affirmationText}>
      <p>
        Continuing for
        {' '}
        {student.firstName}
        {' '}
        {student.lastName}
      </p>
      <p className={styles.consentMsg}>
        By continuing, the user affirms that they are the legal guardian or
        close relative of the student whose image(s)
        they are requesting and that they authorize Shoob Photography to print and
        mail portraits of them to their home address.
      </p>
      <Button rounded variant="primary" type="button" onClick={handleContinue}>
        Continue
      </Button>
    </div>
  );
}
